import UserGroupIcon from '@assets/images/icons/user-group.svg?react'
import { symbols as CURRENCIES } from '@components/ArtBoard/Estimator/constants'
import { Panel } from '@lib/components'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import {
  addEstimateLineItem,
  updateEstimatesTaxValue,
} from '@store/reducers/estimates/actions'
import type { AppState } from '@store/types'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { Settings, SummaryTable, Table } from './components'
import css from './Estimator.module.scss'

export const Estimator: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  const currency = useSelector(
    migrationProjectSelector.getProjectEstimateCurrency
  )
  const estimateUnits = useSelector(
    migrationProjectSelector.getProjectEstimateUnits
  )
  const vat = useSelector(migrationProjectSelector.getProjectEstimateVat)
  const privateEstimate = useSelector(
    migrationProjectSelector.getProjectEstimateSettingPrivate
  )

  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const lineItems = useSelector(
    migrationProjectSelector.getProjectEstimateLineItems
  )

  const isReadOnly = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const artboardDisabled = useArtBoardDisabled()

  const copyUrl = `${window.location.origin}/${projectId}/pr/estimate`

  const handleOnClose = () => {
    dispatch(artBoardActions.changeMode('edit'))
  }

  const handleAddRow = () => {
    dispatch(addEstimateLineItem())
  }

  const handleUpdateEstimateVat = (taxValue: number) => {
    dispatch(updateEstimatesTaxValue({ taxValue }))
  }

  return (
    <Panel
      title={
        <span className={css.panelTitle}>
          Estimate {privateEstimate && <UserGroupIcon />}
        </span>
      }
      copyUrl={isReadOnly ? copyUrl : undefined}
      renderMenu={
        !isReadOnly
          ? (closeDropdown) => (
              <Settings copyUrl={copyUrl} closeDropdown={closeDropdown} />
            )
          : undefined
      }
      onClose={handleOnClose}
    >
      <Table items={lineItems} currency={currency} />

      {!isReadOnly && (
        <div className={css.addRow}>
          <button
            className={css.addButton}
            disabled={artboardDisabled}
            onClick={handleAddRow}
          >
            <i className="fa fa-plus" />
            Add row...
          </button>
        </div>
      )}

      <SummaryTable
        vat={vat}
        unit={estimateUnits}
        currency={CURRENCIES[currency as keyof typeof CURRENCIES]}
        onVatChange={handleUpdateEstimateVat}
      />
    </Panel>
  )
}
